//tabla 1 encriptar
var tabla2 = [
    { pos2: 1, car2: 'T' },
    { pos2: 10, car2: '7' },
    { pos2: 11, car2: 'G' },
    { pos2: 12, car2: 'Y' },
    { pos2: 13, car2: '5' },
    { pos2: 14, car2: 'M' },
    { pos2: 15, car2: '0' },
    { pos2: 16, car2: 'C' },
    { pos2: 17, car2: 'F' },
    { pos2: 18, car2: 'R' },
    { pos2: 19, car2: 'X' },
    { pos2: 2, car2: 'J' },
    { pos2: 20, car2: '8' },
    { pos2: 21, car2: 'I' },
    { pos2: 22, car2: '4' },
    { pos2: 23, car2: 'U' },
    { pos2: 24, car2: 'L' },
    { pos2: 25, car2: 'A' },
    { pos2: 26, car2: '6' },
    { pos2: 27, car2: 'E' },
    { pos2: 28, car2: '3' },
    { pos2: 29, car2: '¡' },
    { pos2: 3, car2: 'H' },
    { pos2: 30, car2: '9' },
    { pos2: 31, car2: 'V' },
    { pos2: 32, car2: 'O' },
    { pos2: 33, car2: '2' },
    { pos2: 34, car2: 'D' },
    { pos2: 35, car2: 'P' },
    { pos2: 36, car2: 'K' },
    { pos2: 37, car2: 'B' },
    { pos2: 38, car2: '.' },
    { pos2: 39, car2: 'Ñ' },
    { pos2: 4, car2: 'W' },
    { pos2: 40, car2: ',' },
    { pos2: 41, car2: '<' },
    { pos2: 42, car2: '>' },
    { pos2: 43, car2: '?' },
    { pos2: 44, car2: ':' },
    { pos2: 45, car2: ';' },
    { pos2: 46, car2: '¤' },
    { pos2: 47, car2: 'Ú' },
    { pos2: 48, car2: '|' },
    { pos2: 49, car2: '`' },
    { pos2: 5, car2: 'S' },
    { pos2: 50, car2: '~' },
    { pos2: 51, car2: '!' },
    { pos2: 52, car2: '#' },
    { pos2: 53, car2: '$' },
    { pos2: 54, car2: '%' },
    { pos2: 55, car2: '^' },
    { pos2: 56, car2: '&' },
    { pos2: 57, car2: '*' },
    { pos2: 58, car2: '(' },
    { pos2: 59, car2: ']' },
    { pos2: 6, car2: '1' },
    { pos2: 60, car2: '-' },
    { pos2: 61, car2: '_' },
    { pos2: 62, car2: '=' },
    { pos2: 63, car2: '+' },
    { pos2: 64, car2: '/' },
    { pos2: 65, car2: ' ' },
    { pos2: 66, car2: ']' },
    { pos2: 67, car2: '[' },
    { pos2: 68, car2: '}' },
    { pos2: 69, car2: '{' },
    { pos2: 7, car2: 'N' },
    { pos2: 70, car2: '¿' },
    { pos2: 8, car2: 'Z' },
    { pos2: 9, car2: 'Q' }
];
//tabla 1 desenpcritar AJ 
var tabla1 = [
    { pos1: 1, car1: 'A' },
    { pos1: 10, car1: 'J' },
    { pos1: 11, car1: 'K' },
    { pos1: 12, car1: 'L' },
    { pos1: 13, car1: 'M' },
    { pos1: 14, car1: 'N' },
    { pos1: 15, car1: 'O' },
    { pos1: 16, car1: 'P' },
    { pos1: 17, car1: 'Q' },
    { pos1: 18, car1: 'R' },
    { pos1: 19, car1: 'S' },
    { pos1: 2, car1: 'B' },
    { pos1: 20, car1: 'T' },
    { pos1: 21, car1: 'U' },
    { pos1: 22, car1: 'V' },
    { pos1: 23, car1: 'W' },
    { pos1: 24, car1: 'X' },
    { pos1: 25, car1: 'Y' },
    { pos1: 26, car1: 'Z' },
    { pos1: 27, car1: '0' },
    { pos1: 28, car1: '1' },
    { pos1: 29, car1: '2' },
    { pos1: 3, car1: 'C' },
    { pos1: 30, car1: '3' },
    { pos1: 31, car1: '4' },
    { pos1: 32, car1: '5' },
    { pos1: 33, car1: '6' },
    { pos1: 34, car1: '7' },
    { pos1: 35, car1: '8' },
    { pos1: 36, car1: '9' },
    { pos1: 37, car1: ' ' },
    { pos1: 38, car1: 'Ñ' },
    { pos1: 39, car1: '@' },
    { pos1: 4, car1: 'D' },
    { pos1: 40, car1: '.' },
    { pos1: 41, car1: '!' },
    { pos1: 42, car1: '#' },
    { pos1: 43, car1: '$' },
    { pos1: 44, car1: '%' },
    { pos1: 45, car1: '^' },
    { pos1: 46, car1: '&' },
    { pos1: 47, car1: '*' },
    { pos1: 48, car1: '[' },
    { pos1: 49, car1: ']' },
    { pos1: 5, car1: 'E' },
    { pos1: 50, car1: '-' },
    { pos1: 51, car1: '_' },
    { pos1: 52, car1: '=' },
    { pos1: 53, car1: '+' },
    { pos1: 54, car1: '/' },
    { pos1: 55, car1: ' ' },
    { pos1: 56, car1: ']' },
    { pos1: 57, car1: '[' },
    { pos1: 58, car1: '}' },
    { pos1: 59, car1: '{' },
    { pos1: 6, car1: 'F' },
    { pos1: 60, car1: ',' },
    { pos1: 61, car1: '<' },
    { pos1: 62, car1: '>' },
    { pos1: 63, car1: '?' },
    { pos1: 64, car1: ':' },
    { pos1: 65, car1: ';' },
    { pos1: 66, car1: " " },
    { pos1: 67, car1: "';" },
    { pos1: 68, car1: '|' },
    { pos1: 69, car1: '`' },
    { pos1: 7, car1: 'G' },
    { pos1: 70, car1: '~' },
    { pos1: 8, car1: 'H' },
    { pos1: 9, car1: 'I' },
];


// export const desencriptarData = (cadenaTexto) => {
//     if (cadenaTexto !== '' && cadenaTexto !== null) {
//         let indice = 70;
//         let i = 0;
//         let entradax = '';
//         const longi = cadenaTexto.length;
//         let espacio = 'N';

//         while (i < longi) {
//             const cara1 = cadenaTexto.charAt(i);

//             let pos2 = tabla2
//                 .filter(function(e) { return e.car2 === cara1; })
//                 .map(function(e) { return e.pos2; });

//             let xInd;
//             if (pos2.length > 0) {
//                 if (pos2[0] - longi < 1) {
//                     xInd = (pos2[0] - longi) + indice;
//                 } else {
//                     xInd = pos2[0] - longi;
//                 }
//                 if (espacio === 'N') {
//                     let tabinx = tabla1.filter(function(e) { return e.pos1 === xInd; }).map(function(e) { return e.car1; });
//                     entradax = entradax + (tabinx.length > 0 ? tabinx[0] : ' ');
//                 } else {
//                     let tabinx = tabla1.filter(function(e) { return e.pos1 === xInd; }).map(function(e) { return e.car1; });
//                     entradax = entradax + ' ' + (tabinx.length > 0 ? tabinx[0] : ' ');
//                     espacio = 'N';
//                 }
//             } else {
//                 entradax = entradax + ' ';
//             }

//             i++;
//         }
//         return entradax;
//     } else {
//         return cadenaTexto;
//     }
// }

// Preprocesamiento de tablas para un acceso más eficiente
// const car2ToPos2 = new Map(tabla2.map(item => [item.car2, item.pos2]));
// const pos1ToCar1 = new Map(tabla1.map(item => [item.pos1, item.car1]));

// export const desencriptarData = (cadenaTexto) => {
//     if (!cadenaTexto) {
//         return cadenaTexto;
//     }

//     const indice = tabla1.length;
//     let resultado = '';

//     for (let i = 0; i < cadenaTexto.length; i++) {
//         const caracter = cadenaTexto.charAt(i);
//         const pos2 = car2ToPos2.get(caracter);

//         if (pos2 !== undefined) {
//             // Asegurar que el índice esté dentro del rango permitido
//             let xInd = ((pos2 - cadenaTexto.length - 1 + indice) % indice) + 1;
//             const car1 = pos1ToCar1.get(xInd) || ' ';
//             resultado += car1;
//         } else {
//             resultado += ' ';
//         }
//     }

//     return resultado;
// };

// Función para desencriptar una cadena de texto
export const desencriptarData = (cadenaTexto) => {
    // Verifica que la cadena de texto no esté vacía ni sea nula
    if (cadenaTexto !== '' && cadenaTexto !== null) {
        let indice = 70; // Valor constante usado en el cálculo de desencriptación
        let i = 0; // Contador para el bucle
        let entradax = ''; // Almacena el resultado del texto desencriptado
        const longi = cadenaTexto.length; // Longitud de la cadena de texto
        let espacio = 'N'; // Controlador para la inserción de espacios en el resultado

        // Bucle que se ejecuta mientras no se alcance el final de la cadena de texto
        while (i < longi) {
            const cara1 = cadenaTexto.charAt(i); // Extrae el carácter actual de la cadena de texto

            // Busca en tabla2 una coincidencia para el carácter actual y obtiene su posición
            let pos2 = tabla2
                .filter(function(e) { return e.car2 === cara1; })
                .map(function(e) { return e.pos2; });
            //console.log(pos2,'pos2')

            let xInd; // Variable para calcular la nueva posición tras desencriptar
            if (pos2.length > 0) {
                // Calcula la nueva posición del carácter
                if (pos2[0] - longi < 1) {
                    xInd = (pos2[0] - longi) + indice;
                } else {
                    xInd = pos2[0] - longi;
                }
                // Si no se debe insertar un espacio, añade el carácter desencriptado a entradax
                if (espacio === 'N') {
                    let tabinx = tabla1.filter(function(e) { return e.pos1 === xInd; }).map(function(e) { return e.car1; });
                    entradax = entradax + (tabinx.length > 0 ? tabinx[0] : ' ');
                } else {
                    // Si se debe insertar un espacio, lo añade antes del carácter desencriptado
                    let tabinx = tabla1.filter(function(e) { return e.pos1 === xInd; }).map(function(e) { return e.car1; });
                    entradax = entradax + ' ' + (tabinx.length > 0 ? tabinx[0] : ' ');
                    espacio = 'N'; // Resetea el controlador de espacio
                }
            } else {
                // Si no hay coincidencia en tabla2, añade un espacio en el resultado
                entradax = entradax + ' ';
            }

            i++; // Incrementa el contador para pasar al siguiente carácter
        }
        // Devuelve la cadena de texto desencriptada
        return entradax;
    } else {
        // Si la cadena de texto está vacía o es nula, devuelve la cadena original
        return cadenaTexto;
    }
}

export const encryptarData=(cadenaTexto)=> {
    // Verifica si cadenaTexto no está vacía y no es nula.
    if (cadenaTexto != '' && cadenaTexto != null) {
        let indice = 70; // Inicializa un valor para el índice.
        let i = 0;         // Inicializa el contador para el bucle while.
        let entradax = ''; // Inicializa una cadena vacía para almacenar el resultado.
        const longi = cadenaTexto.length; // Almacena la longitud de cadenaTexto.
        let espacio = 'N'; // Inicializa una variable para manejar espacios.
        let ClaveOut = ''; // Inicializa una variable ClaveOut (no usada en este fragmento).

        // Bucle while que recorre cada carácter de cadenaTexto.
        while (i < longi) {
            const cara1 = cadenaTexto.charAt(i); // Obtiene el carácter en la posición actual.
            // Busca el carácter en tabla1 y obtiene su posición correspondiente.
            let pos2 = this.tabla1
                .filter(e => e.car1 === cara1).map(e => e.pos1);

            let xInd; // Declara una variable para almacenar un índice calculado.
            // Verifica si pos2 tiene algún valor.
            if (pos2) {
                // Calcula el nuevo índice basado en pos2, longi e indice.
                if ((pos2[0] + longi - indice) > 0) {
                    xInd = (pos2[0] + longi) - indice;
                } else {
                    xInd = pos2[0] + longi;
                }
                let tabinx = null; // Declara una variable para almacenar el resultado de la búsqueda en tabla2.
                if (espacio === 'N') {
                    // Busca el carácter correspondiente en tabla2 y lo añade a entradax.
                    tabinx = this.tabla2.filter(e => e.pos2 === xInd).map(e => e.car2);
                    entradax = entradax + (tabinx.length > 0 ? tabinx[0] : ' ');
                } else {
                    // Similar al caso anterior, pero añade un espacio antes del carácter.
                    tabinx = this.tabla2.filter(e => e.pos2 === xInd).map(e => e.car2);
                    entradax = entradax + ' ' + (tabinx.length > 0 ? tabinx[0] : ' ');
                    espacio = 'N';
                }
            } else {
                entradax = entradax + ' ';
            }

            i++;
        }

        return entradax;
    } else {
        return cadenaTexto;
    }
}


